
<template>
  <li
    class="group"
    :class="[
      !removeTitle && 'space-y-2',
      !disabled ? 'cursor-cell' : 'cursor-pointer',
    ]"

    @click="addBlock"
  >
    <h4 v-if="!removeTitle" class="group-hover:underline flex items-center">
      {{ title }}
    </h4>

    <div
      class="relative overflow-hidden rounded-lg border border-gray-200"
      :class="[height || 'h-[13.625em]', wrapperClass]"
    >
      <iframe
        class="origin-top-left"

        width="1280"
        height="800"
        :src="src"
        :style='`transform: ${scale || "scale(.26, .26)"}${iframeTransform ? ` ${iframeTransform}` : ";"}`'
      ></iframe>

      <div class="w-full h-full absolute left-0 top-0"></div>
    </div>
  </li>
</template>

<script>

import { mapGetters } from "vuex"

export default {
  props: ['id', 'title', 'role', 'block', 'variant', 'removeTitle', 'height', 'scale', 'iframeTransform', 'wrapperClass', 'disabled'],
  methods: {
    addBlock() {
      if (this.disabled) return;

      const block = this.block
      this.$store.dispatch("editor/addBlock", {
        page: this.page, role: this.role,
        blocks: [...this.roleBlocks, {
          id: `${block.id}_${(new Date()).getTime()}`,
          title: block.title,
          role: block.role,
          category: block.category,
          states: block.states,
        }]
      })
    },
  },
  computed: {
    ...mapGetters({
      link: 'editor/fullDomainLink',
      config: 'editor/config',
      page: 'editor/page',
      context: 'editor/context',
      containers: 'editor/pageContainers',
    }),

    roleBlocks() {
      return (this.containers[this.role] || [])
    },
    src() {
      return `${this.link}/rest/V1/editor/preview-block/${this.id}?&snippet=true&tailwind_config=${
        encodeURIComponent(JSON.stringify(this.config.tailwindConfig))
      }&context=${
        encodeURIComponent(JSON.stringify(this.context))
      }${this.variant && `&variant=${this.variant}`}`
    },
  },
}

</script>
